import api from '@/apis/di/fundStructureAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Cơ cấu vốn
export const useFundStructureComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onFundStructureComboboxLoadData = (payload, row, column) => {
    payload.sort = 'fund_structure_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let ors1 = [{ Field: 'is_parent', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: ors1 },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const fundStructureComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã cơ cấu vốn',
        dataField: 'fund_structure_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên cơ cấu vốn',
        dataField: 'fund_structure_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'fund_structure_name',
    valueField: 'fund_structure_id',
    queryMode: 'remote',
    quickSearch: 'FundStructureQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    dropdownWidth: 600,
    comboboxLoadData: onFundStructureComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    fundStructureComboConfig,
    onFundStructureComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
